const axios = require('axios')

const api = axios.create({
    baseURL: `${process.env.VUE_APP_HOST_FUNCTIONS}`
})

export default api
